<design-slide-up-card #card [isCardOpen]="!!isCardOpen" [displayBackground]="true" [title]="title"
  [roleDialog]="true"
  [focusInitialOnHeaderBack]="false"
  (onHeaderButtonClick)="routePlanningService._mapOverlaySub.next(null); closeCard()" [icon]="iconName"
  class="route-planner-autocomplete" [class]="direction">
  <div class="flex flex-col py-4 px-2 gap-4 min-h-0 flex-1">
    <!--
      a11y: WAI-ARIA combobox-autocomplete-list pattern.
      Input exposes role="combobox" + aria-autocomplete="list" + aria-controls/expanded/activedescendant
      via comboboxRole inputs on <mot-input>. Stations list below is the listbox with role="option" rows.
    -->
    <mot-input #input [autoFocus]="false" [formControl]="formControl" [displayErrors]="false" appearance="fill" [icon]="
          input.formControl?.value?.length >= autoCompleteMinChar
            ? 'close'
            : null
        " iconClass="text-xl cursor-pointer" prefixIcon="search" prefixIconClass="text-xl" (onIconClick)="clearValue()"
      [iconButtonAriaLabel]="clearText" [placeholder]="searchStationText"
      [ariaLabel]="searchStationText"
      [comboboxRole]="true"
      [comboboxControlsId]="listboxId"
      [comboboxExpanded]="isListboxExpanded"
      [comboboxActiveDescendant]="activeOptionId"
      (keydown)="onComboboxKeydown($event)"
      class="bg-transparent w-full leading-loose !text-default" [dir]="direction" [attr.cdkFocusInitial]="true" />
      @if (!!this.formControl.value) {
        @if (results$ | async; as stations) {
          @if (
            formControl.value.length >= autoCompleteMinChar &&
            (emptyResults$ | async) == true) {
            <div class="px-2">
              <p class="m-0 text-wrap">
                {{noStationFoundText}} {{ formControl.value }}
              </p>
            </div>
          } @else {
            <!--
              a11y: listbox owns role="listbox" + accessible name. Each station row is a
              role="option" <li> wrapper around the visual <app-station-details>.
              mousedown.preventDefault keeps DOM focus on the combobox input so the
              listbox is not dismissed before click fires.
            -->
            <ul
              [id]="listboxId"
              role="listbox"
              [attr.aria-label]="searchStationText"
              tabindex="-1"
              class="list-none m-0 p-0 py-4 flex flex-col gap-2 overflow-y-auto"
              (focus)="onListboxContainerFocus($event)"
              (keydown)="onListboxKeydown($event)">
              @for (station of stations; track station; let i = $index) {
                <li
                  [id]="getOptionId(i)"
                  role="option"
                  tabindex="-1"
                  [attr.aria-selected]="activeOptionIndex === i ? 'true' : 'false'"
                  class="rounded p-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0C3058]"
                  [class.bg-primary-50]="activeOptionIndex === i"
                  (mousedown)="$event.preventDefault()"
                  (focus)="onOptionFocus(i)"
                  (click)="chooseValue(station.value, !!data.saveResultToStorage)">
                  <app-station-details [station]="station.value" />
                </li>
              }
            </ul>
          }
        }
      } @else {
        @if (!data.hideFeed) {
          <app-stations-auto-complete-feed [favoriteStations]="favoriteStations"
            [displayCurrentLocation]="!!locationPermissionGranted" (onLastSearchClick)="chooseValue($event, false)"
            (onMapClick)="handleMapClick()" (onCurrentLocationClick)="handleCurrentLocationClick()" [isCurrentLocationLoading]="isCurrentLocationLoading"/>
        }
      }


    </div>
  </design-slide-up-card>